import React, { useContext, useState } from "react";
import CommonLayout from "../Layout/CustomLayout";
import { Card, Button, Input, Form, message } from "antd";
import inputStyles from "../../styles/Custom/Input.module.css";
import btnStyles from "../../styles/Custom/Button.module.css";
import styles from "../../styles/Custom/Dashboard/Users.module.css";
import AccountHeader from "./AccountHeader";
import AccountTabs from "./AccountTabs";
import DoctorLayout from "../Layout/DoctorLayout/index";
import {
  changePasswordApi,
  userMetaDataApi,
} from "../../services/auth.services";
import { getCookie } from "../../helpers/localStorage";
import { UserContext } from "../../context/UserContext";
import PatientTypeContextProvider from "../Layout/DoctorLayout/PatientTypeContextProvider";
import { FacilityID, Role } from "../../constants/defaultKeys";
import useIsMobile from "../../hooks/useIsMobile";

const Password = ({ sideContent }) => {
  const { userDetails, setUserDetails } = useContext(UserContext);
  const [updatePassword, setUpdatePassword] = useState(false);
  const [form] = Form.useForm();
  const isMobile = useIsMobile();

  const onFinish = async (values) => {
    try {
      const resp = await changePasswordApi({
        current_password: values?.current_password,
        new_password: values?.new_password,
      });
      if (resp) {
        setUpdatePassword(false);
        message.success(resp?.data?.message);
        getUserData();
        form.resetFields();
      }
    } catch (error) {
      message.error(error?.response?.data?.message);
    }
  };
  const getUserData = async () => {
    try {
      let resp = await userMetaDataApi();
      const orgId = getCookie("organisation_id");
      const activeOrg = orgId
        ? resp?.data?.organizations?.filter((org) => org?.org_id == orgId)?.[0]
        : {};
      const currFacility = getCookie(FacilityID)
        ? getCookie(FacilityID)
        : activeOrg?.roles?.[0]?.facility_id;
      const currRole = getCookie(Role)
        ? getCookie(Role)
        : activeOrg?.roles?.[0]?.role;
      setUserDetails({
        ...resp?.data,
        activeOrg: activeOrg,
        currFacility,
        currRole,
      });
    } catch (error) {
      console.log(error);
    }
  };
  const commonProfile = () => {
    return (
      <Card
        className={`${styles.personalDetailsCard} ${styles.accountProfileCard} centeredCard`}
      >
        <Form
          onFinish={onFinish}
          onFinishFailed={(values) => console.log(values)}
          onValuesChange={() => setUpdatePassword(true)}
          className={styles.accountForm}
          layout="vertical"
          form={form}
          // requiredMark={false}
        >
          <Form.Item label="Current password" name="current_password">
            <Input.Password
              placeholder="Enter current password"
              className={inputStyles.mdInput}
            />
          </Form.Item>
          <Form.Item
            label="New password"
            name="new_password"
            rules={[
              { required: true, message: "Please input your password!" },
              {
                message:
                  "Password must have at least 8 characters, including uppercase, lowercase, digit, and special character.",
                pattern: new RegExp(
                  "^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
                ),
              },
            ]}
          >
            <Input.Password
              placeholder="Enter new password"
              className={inputStyles.mdInput}
            />
          </Form.Item>
          <Form.Item
            label="Confirm password"
            name="confirm_new_password"
            rules={[
              { required: true, message: "Please confirm your password!" },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "The new passwords that you entered do not match!"
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm new password"
              className={inputStyles.mdInput}
            />
          </Form.Item>
        </Form>
      </Card>
    );
  };
  const defaultRole = userDetails?.currRole || getCookie(Role);

  const accountBody = (
    <>
      {isMobile && (
        <div className={styles.accountTabsMobileBar}>
          <AccountTabs />
        </div>
      )}
      {commonProfile()}
    </>
  );

  return (
    <PatientTypeContextProvider>
      {defaultRole === "Organization_Owner" ||
      defaultRole === "Organization_Admin" ||
      defaultRole === "Facility_Admin" ||
      defaultRole === "Receptionist" ? (
        <CommonLayout
          sideContent={sideContent}
          header={<AccountHeader />}
          footer={
            updatePassword && (
              <div className="flex-end" style={{ gap: "24px" }}>
                <Button
                  className={btnStyles.mdBtn}
                  onClick={() => setUpdatePassword(false)}
                >
                  Cancel
                </Button>

                <Button
                  type="primary"
                  onClick={() => form.submit()}
                  className={btnStyles.mdBtn}
                >
                  Save
                </Button>
              </div>
            )
          }
        >
          {accountBody}
        </CommonLayout>
      ) : (
        <DoctorLayout
          header={isMobile ? true : <AccountHeader showTitle={false} />}
          footer={
            updatePassword && (
              <div className="flex-end" style={{ gap: "24px" }}>
                <Button
                  className={btnStyles.mdBtn}
                  onClick={() => setUpdatePassword(false)}
                >
                  Cancel
                </Button>

                <Button
                  type="primary"
                  onClick={() => form.submit()}
                  className={btnStyles.mdBtn}
                >
                  Save
                </Button>
              </div>
            )
          }
          headerExtra={false}
        >
          {accountBody}
        </DoctorLayout>
      )}
    </PatientTypeContextProvider>
  );
};

export default Password;
